module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nif(formMapping.fieldConfig && formMapping.fieldConfig.isFilterField){\n%>\n<span></span>\n<%\n}\nelse {\n%>\n<div>\n<div class=\"symbol\">\n<i class=\"fi <%- (utils.isEmpty(model.dataJSON) ? 'fi-circle' : 'fi-check-circle hasContent') %>\"></i>\n</div>\n<%- include('../elements/buttons/default', { formMapping: { buttonType: 'edit', text: 'EDIT' } }); %>\n</div>\n<%\n}\n%>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\fields\\json-editor-button.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
if(formMapping.fieldConfig && formMapping.fieldConfig.isFilterField){

    ; __line = 3
    ; __append("\n<span></span>\n")
    ; __line = 5
    ; 
}
else {

    ; __line = 8
    ; __append("\n<div>\n<div class=\"symbol\">\n<i class=\"fi ")
    ; __line = 11
    ; __append( (utils.isEmpty(model.dataJSON) ? 'fi-circle' : 'fi-check-circle hasContent') )
    ; __append("\"></i>\n</div>\n")
    ; __line = 13
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'edit', text: 'EDIT' } }) )
    ; __append("\n</div>\n")
    ; __line = 15
    ; 
}

    ; __line = 17
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\fields\json-editor-button.ejs

}